var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopySvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy-f_svgrepo.com"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.25V14.6875C12 16.3319 12.9874 17.6736 14.2265 17.7468L14.3333 17.75H20V20.375C20 21.8247 19.1046 23 18 23H10C8.89543 23 8 21.8247 8 20.375V9.875C8 8.42525 8.89543 7.25 10 7.25H12ZM22.5 2C23.3284 2 24 2.88144 24 3.96875V14.4688C24 15.5561 23.3284 16.4375 22.5 16.4375H14.5C13.6716 16.4375 13 15.5561 13 14.4688V3.96875C13 2.88144 13.6716 2 14.5 2H22.5Z",
    fill: "#FFDCA8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopySvg);
export default __webpack_public_path__ + "static/media/CopySvg.015b542d70e0709e47265d90d663a419.svg";
export { ForwardRef as ReactComponent };